<template>
  <div style="overflow-x: hidden;background-color: white;">
    <div class="account-pages">
      <div class="nav_area mb-3">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 d-flex d-none d-md-block">
              <div class="w-fit-content">
              <router-link
                  to="/login"
                  class="mb-2 mb-md-4 d-block auth-logo mt-4"
                >
                  <img
                    src="@/assets/images/logo-dark.png"
                    alt
                    height="65"
                    class="logo logo-dark"
                  />
                  <img
                    src="@/assets/images/logo-light.png"
                    alt
                    height="22"
                    class="logo logo-light"
                  />
                </router-link>
              </div>
            </div>
            <!-- end col -->
            <div class="col-12 col-md-6 mb-2 mb-md-0 d-flex text-end justify-content-end align-items-center">
              <div class="row justify-content-end">
                <a href="https://www.newpages.com.my/v2/en/register.html" class="font-size-16 text-muted">
                 {{ $t('lang.new_login.join_us_now') }} <i class="mdi mdi-rocket-launch text-primary ms-1"></i></a>
                <div class="row d-flex text-align-last-end justify-content-end align-items-center">
                  <!-- <div class="col-auto">
                    <a :href="'javascript:void(0)'" v-if="language != 'en'" @click="switchLanguage()">English</a>
                    <span v-else-if="language == 'en'">English</span>
                  </div>
                  <div class="col-auto">
                    <a :href="'javascript:void(0)'" v-if="language != 'zh'" @click="switchLanguage()">中文</a>
                    <span v-else-if="language == 'zh'">中文</span>
                  </div> -->
                          <b-dropdown variant="white" right toggle-class="header-item"    class="custom-dropdown">
          <template v-slot:button-content>
            <img :src="flag" alt="Header Language" height="12" />
            <span class="align-middle ms-2">{{ text }}</span>
          </template>
          <b-dropdown-item class="notify-item" v-for="(entry, i) in languages" :key="`Lang${i}`" :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :link-class="{ active: entry.language === current_language }">
            <img :src="`${entry.flag}`" alt="user-image" class="me-1" height="12" />
            <span class="align-middle ms-2">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
      </div>
      <div class="container">
        <div class="row"></div>
        <div class="row justify-content-center">
          <div class="col-12 col-lg-6 col-xl-7 d-flex flex-column justify-content-center d-none d-lg-flex">
            <div class="banner_area" style="padding-top: calc(100% * 640/1460);">
              <iframe :src="iframeLink" frameborder="0"></iframe>
            </div>
            <div class="banner_area" style="padding-top: calc(100% * 127/1000);">
              <img src="https://www.newpages.com.my/v2/en/img/scan_qrcode_banner.png" alt="">
            </div>
          </div>
          <!-- end col -->
          <div class="col-md-8 col-lg-6 col-xl-5 d-flex flex-column justify-content-center">
            <div class="card position-relative my-2" style="max-width: 450px;margin-left: auto;margin-right: auto;">
              <div class="card-body p-4 px-5 responsive-login" >
                 <a href="javascript:void(0)" @click="toggleQRLogin" class="position-absolute top-0 end-0 mt-2 me-2" v-if="!showQRLogin">
                  <img src="@/assets/images/qr_code/scan_login_qr.png" width="55"> 
                  <img src="@/assets/images/qr_code/tooltip_en.png" id="tooltip">
                </a> 
                <a href="javascript:void(0)" @click="toggleQRLogin" class="position-absolute top-0 end-0 mt-2 me-2" v-else >
                  <img src="@/assets/images/qr_code/desktop_login.png" width="60">
                </a> 

                <div class="col-lg-12">
                  <div class="text-center">
                    <router-link
                      to="/login"
                      class="mb-4 d-block auth-logo mt-4"
                    >
                      <img
                        src="@/assets/images/logo-dark.png"
                        alt
                        height="65"
                        class="logo logo-dark"
                      />
                      <img
                        src="@/assets/images/logo-light.png"
                        alt
                        height="22"
                        class="logo logo-light"
                      />
                    </router-link>
                  </div>
                </div>
                <div class="text-center mt-2">
                  <h1 class="text-primary font-size-17"></h1>
                  <p class="text-muted" style="height: 30px;">
                    {{ $t('lang.new_login.sign_in_label') }}
                  </p>
                </div>
                 <div class="p-2" v-if="!showQRLogin">
                  <div>
                    <b-alert variant="danger" v-model="isAuthError">
                      {{ authError }}
                    </b-alert>
                  </div>

                  <form @submit.prevent="LogIn" class="font-size-15">
                    <div class="mb-3">
                      <label for="username" class="form-label fw-normal"
                        ><i class="uil-user me-1 text-secondary"></i>
                        {{ $t('lang.new_login.user_name') }}</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        value=""
                        name="username"
                        autocomplete="off"
                        :placeholder="$t('lang.new_login.user_name')"
                        v-model="input_username"
                        :class="{
                          'is-invalid': submitted && $v.input_username.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.input_username.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.input_username.required"
                          >{{ $t('lang.new_login.username_is_required') }}</span
                        >
                      </div>
                    </div>
                    <div class="mb-3 position-relative">
                      <label for="password" class="form-label fw-normal"
                        ><i class="uil-lock me-1 text-secondary"></i> {{ $t('lang.new_login.password') }}
                      </label>
                      <div class="float-end">
                        <router-link to="/reset-password" class="text-muted">
                          {{ $t('lang.new_login.forget_password') }}
                        </router-link>
                      </div>
                      <input
                        :type="passwordFieldType"
                        class="form-control"
                        id="password"
                        value=""
                        name="password"
                        autocomplete="off"
                        :placeholder="$t('lang.new_login.password')"
                        v-model="input_password"
                        :class="{
                          'is-invalid': submitted && $v.input_password.$error,
                        }"
                      />

                      <div
                        v-if="submitted && !$v.input_password.required"
                        class="invalid-feedback"
                      >
                        {{ $t('lang.new_login.password_is_required') }}
                      </div>

                      <div
                        id="eye"
                        class="user-select-none"
                        @click="switchVisibility"
                      >
                        <i
                          :class="classicon"
                          id="eyetype"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div class="mb-3"></div>
                    <button
                      type="submit"
                      class="btn btn-primary w-100 g-recaptcha"
                      name="button"
                      id="button"
                      :data-sitekey="grecaptcha_sitekey" 
                      data-callback='onSubmit' 
                      data-action='submit'
                    >
                      {{ $t('lang.new_login.sign_in') }}
                    </button>
                  </form>

                  <p class="text-muted text-center mb-0 mt-3 pt-4 border-top" style="height: 60px;">
                    <i class="fas fa-exclamation-circle text-warning"></i>
                    {{ $t('lang.new_login.sop_text') }}
                  </p>
                  
                </div>
                <div class="p-2" v-else>
                  <div class="my-3" id="divQR">
                    <table width="100%" border="0" cellspacing="0" cellpadding="10">
                      <tbody><tr>
                        <td colspan="2" align="left"><div style="width:100%;height:180px; text-align:center">
                            <div class="position-relative mb-4"> 
                              <img :src="qrCode" width="150" height="150" border="0" v-if="qrCode">
                              <img src="@/assets/images/qr_code/qrblack.png" width="150" height="150" border="0" v-else> 
                              
                              <div v-if="QrExpired">
                              <span id="expiredtxt" class="fw-medium">{{QrError|| 'QR Code Expired'}} </span> 
                              <a href="javascript:void(0)" @click="getQRCode()" id="refreshbutton">{{ $t('lang.new_login.refresh') }}</a> 
                              </div>
                              
                              </div>
                            <div>
                              <table style="width:180px; margin:auto; padding-top:5px;">
                                <tbody><tr>
                                  <td valign="top"><img src="@/assets/images/qr_code/qrtv-icon-ios.png" width="48"></td>
                                  <td style="font-size:12px;vertical-align: middle; text-align: left"> 
                                    {{ $t('lang.new_login.open_app') }} {{ $t('lang.new_login.scan_to_login') }} 
                                  </td>
                                </tr>
                              </tbody></table>
                            </div>
                          </div></td>
                      </tr>
                    </tbody></table>
                    <br>
                  </div>
                </div>
                <!-- end card-body -->
              </div>
              <!-- end card -->
            </div>
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
        <div class="row">
            <div class="col-12">
              <div class="mt-2 font-size-12 text-center">
                <p>
                  © 2007-{{ new Date().getFullYear() }} NEWPAGES NETWORK SDN BHD
                  (1033406-U)
                </p>
              </div>
            </div>
          </div>
          <!-- end row -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" module></style>

<script>
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import axios from "axios";

const CancelToken = axios.CancelToken;
let cancel;
/**
 * Login component
 */

export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      input_username: "",
      input_password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      passwordFieldType: "password",
      classicon: "uil uil-eye-slash",
      token: "",
      grecaptcha_sitekey:"",
      recaptcha_token:"",
      showQRLogin:false,
      qrCode:"",
      QrExpired:false,
      Hash:"",
      timer: null,
      iframeLink:null,
      productShowCase:[],
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/china.png"),
          language: "zh",
          title: "中文",
        },
      ],
      current_language: this.$i18n.locale,
      text: null,
      flag: null,
    };
  },
  validations: {
    input_username: {
      required,
    },
    input_password: {
      required,
    },
  },

  computed: {},
  created() {
    if (appConfig.backend_debug == true){
      this.input_username = appConfig.username;
      this.input_password = appConfig.password;
    }
    if (appConfig.baseUrl == "https://alpha-server.newpages.com.my"){
      this.grecaptcha_sitekey = appConfig.grecaptcha_sitekey_test
    }else{
      this.grecaptcha_sitekey = appConfig.grecaptcha_sitekey
    }
    
    this.getData();
    
    if(this.getCookie("uid")){
      this.input_username = this.getCookie("uid");
      document.cookie = "uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "hash=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      if(localStorage.getItem('error_mes')){
        this.authError = localStorage.getItem('error_mes');
        this.isAuthError = true;
        localStorage.removeItem('error_mes');
      }
    }else{
      localStorage.clear();
    }
    // alert(this.$cookies)

    var self = this
    window.grecaptcha.ready(function() {
    window.grecaptcha.execute(self.grecaptcha_sitekey, {action: 'submit'}).then(function(token) {
          // Add your logic to submit to your backend server here.
          console.log(token)
          self.recaptcha_token = token
      });
    });

    // if (self.language == null) {
    //   self.language = 'en';
    //   localStorage.setItem("setting_language", "en");
    // } else {
    //   self.language = localStorage.getItem("setting_language");
    // }

    // self.$i18n.locale = self.language;
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === this.$i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    document.body.classList.add("authentication-bg");

    if (this.language == null) {
      this.language = "en";
    } 
    this.$i18n.locale = this.language;    
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    switchLanguage() {
      if (this.language == 'en') {
        this.language = "zh";
      } else {
        this.language = "en";
      }

      this.$i18n.locale = this.language;
    },
    switchVisibility() {
      (this.classicon =
        this.classicon === "uil uil-eye-slash"
          ? "uil uil-eye"
          : "uil uil-eye-slash"),
        (this.passwordFieldType =
          this.passwordFieldType === "password" ? "text" : "password");
    },
    toggleQRLogin(){
      if (!this.showQRLogin) {
        this.showQRLogin = true;
        this.getQRCode()
      } else {
        this.showQRLogin = false;
        clearInterval(this.timer);
      }
    },
    getQRCode(){
      clearInterval(this.timer);
      this.QrExpired = false
      this.qrCode = ""
      this.QrError = ""
      this.Hash = ""
      if(cancel !== undefined) cancel('');
      var bodyFormData = new FormData();
      axios({
          method: "post",
          url: appConfig.baseUrl + appConfig.nms_path + "/qr_login_code",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
          cancelToken: new CancelToken(c => cancel = c),
        })
        .then((response) => {
            var resData = response.data;
            if (resData.error == 0) {
              if (resData.data.error == 0) {
                this.qrCode = 'data:image/png;base64,'+resData.data.base64_qr_code;
                this.Hash = resData.data.hash
                var self= this
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                   self.CheckQR()
                }, 2000
                )
                console.log(resData)
              } else {
                Swal.fire("Error", resData.data.error_message, "error");
              }
            } else {
              //console.log('error1')
              this.qrCode = ""
              this.$Progress.fail();
              localStorage.clear();
              this.$router.push({
                path: "/login",
              });
            }
            //("JSON" + JSON.stringify(response.data) )
            //console.log("status:" + response.status);
            this.$Progress.finish();
          })
          .catch((error) => {
            this.$Progress.fail();
            this.QrExpired = false
            this.qrCode = ""
            this.QrError = ""
            this.Hash = ""
            console.log(error);
          });
    },
    CheckQR(){
      var device = navigator.userAgent + appConfig.deviceCustom;
      var bodyFormData = new FormData();
      bodyFormData.append("device", device);
      bodyFormData.append("hash", this.Hash);
      axios({
          method: "post",
          url: appConfig.baseUrl + appConfig.nms_path + "/qr_login_code/status",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
            var resData = response.data;
            if (resData.error == 0) {
              if (resData.data.error == 0) {
                console.log(resData)

                
                if (('expired' in resData.data)){
                   if (resData.data.expired==1){
                    this.qrCode = ''
                    this.QrExpired = true
                    this.QrError = ''
                    clearInterval(this.timer);
                  }
                } 
                else{
                  console.log('can set login detail')
                  if (resData.data.redirect_url){
                    const link = document.createElement('a');
                    link.href = resData.data.redirect_url
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return false
                  }
                  var token = resData.data.token;
                  var company_id = resData.data.company_id
                    ? resData.data.company_id
                    : "";
                  var company_name = resData.data.company_name
                    ? resData.data.company_name
                    : "";
                  var company_logo = resData.data.company_logo
                    ? resData.data.company_logo
                    : "";
                  var otp = resData.data.otp;
                  var otp_token = resData.data.otp_tmp_token;
                  var roles = appConfig.roles_test;
                  var masteradmin = appConfig.masteradmin_test;
                  var isMasteradmin = resData.data.is_master_account || "1"
                  if (isMasteradmin == "1"){
                    masteradmin = true
                  }else{
                    masteradmin = false
                  }
                  self.token = token;
                  let is_admin = 0;
                  localStorage.setItem("merchant", company_id);
                  localStorage.setItem("token", token);
                  localStorage.setItem("company_name", company_name);
                  localStorage.setItem("company_logo", company_logo);
                  localStorage.setItem("masteradmin", masteradmin); //masteradmin now i set in page-header.vue and store in store.js * need set this because router index.js got use
                  //localStorage.setItem('roles',"editor")//editor now i set in page-header.vue and store in store.js

                  if (roles != appConfig.roles_editor) {
                    document.head.insertAdjacentHTML(
                      "beforeend",
                      `<style>.roles_button{display:none !important}</style>`
                    );
                  }
                  if (token != null) {
                    this.$emit("logged-in");
                    is_admin = 0;
                    if (this.$route.params.nextUrl != null) {
                      this.$router.push(this.$route.params.nextUrl);
                    } else {
                      if (is_admin == 1) {
                        this.$router.push("/");
                      } else {
                        if (otp == "0") {
                          this.$router.push("/");
                        } else if (otp == "1") {
                          localStorage.setItem("otp_token", otp_token);
                          this.$router.push("/otp");
                        }
                      }
                    }
                  }
                  clearInterval(this.timer);
                }
              } else {
                
                this.qrCode = ''
                this.QrExpired = true
                this.QrError = resData.data.error_message
                Swal.fire("Error", resData.data.error_message, "error");
                clearInterval(this.timer);
              }
            } else {
              //console.log('error1')
              clearInterval(this.timer);
              this.$Progress.fail();
              localStorage.clear();
              this.$router.push({
                path: "/login",
              });
            }
            //("JSON" + JSON.stringify(response.data) )
            //console.log("status:" + response.status);
            this.$Progress.finish();
          })
          .catch((error) => {
            clearInterval(this.timer);
            this.$Progress.fail();
            console.log(error);
          });
    },
    onSubmit(e){
      console.log(e)
    },
    LogIn() {
      const { input_username, input_password,recaptcha_token } = this;
      var self = this
      this.isAuthError = false;
      // stop here if form is invalid
      
      this.$v.$touch();
      this.submitted = true;

      if (this.$v.$invalid) {
        //console.log("error")
      } else {
        self.$Progress.start();

        var device = navigator.userAgent + appConfig.deviceCustom;
        console.log("device" + device);
        var bodyFormData = new FormData();
        bodyFormData.append("username", input_username);
        bodyFormData.append("password", input_password);
        bodyFormData.append("device", device);
        bodyFormData.append("recaptcha_token", recaptcha_token);
        
        axios({
          method: "post",
          url: appConfig.baseUrl + appConfig.nms_path + "/login",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then(function (response) {
            var resData = response.data;
            //console.log("JSON" + JSON.stringify(resData) )
            if (resData.data.error == 1) {
              // Clear the cache in Safari
              if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                window.location.reload(true);
              }
              //console.log('error1')
              self.$Progress.fail();
              self.authError = resData.data.error_message;
              self.isAuthError = true;
            }

            if (resData.data.error == 0) {
              //console.log('not error 0')

              if (resData.data.redirect_url){
                const link = document.createElement('a');
                link.href = resData.data.redirect_url
                document.body.appendChild(link);
                link.click();
                link.remove();
                return false
              }
              var token = resData.data.token;
              var company_id = resData.data.company_id
                ? resData.data.company_id
                : "";
              var company_name = resData.data.company_name
                ? resData.data.company_name
                : "";
              var company_logo = resData.data.company_logo
                ? resData.data.company_logo
                : "";
              var otp = resData.data.otp;
              var otp_token = resData.data.otp_tmp_token;
              var roles = appConfig.roles_test;
              var masteradmin = appConfig.masteradmin_test;
              var isMasteradmin = resData.data.is_master_account || "1"
              if (isMasteradmin == "1"){
                masteradmin = true
              }else{
                masteradmin = false
              }
              self.token = token;
              // let loginData = {
              //   "merchant": company_id,
              //   "token": token,
              //   "company_name": company_name,
              //   "company_logo": "https://www.newpages.com.my/includes/resize_image.php?image=../attachments/tm/"+company_logo+"&new_width=120&new_height=120resData.logo",
              //   "masteradmin": true,
              //   "roles": "editor",
              // }
              // self.$store.commit('saveData', loginData);
              let is_admin = 0;
              localStorage.setItem("merchant", company_id);
              localStorage.setItem("token", token);
              localStorage.setItem("company_name", company_name);
              localStorage.setItem("company_logo", company_logo);
              localStorage.setItem("masteradmin", masteradmin); //masteradmin now i set in page-header.vue and store in store.js * need set this because router index.js got use
              //localStorage.setItem('roles',"editor")//editor now i set in page-header.vue and store in store.js

              if (roles != appConfig.roles_editor) {
                document.head.insertAdjacentHTML(
                  "beforeend",
                  `<style>.roles_button{display:none !important}</style>`
                );
              }
              if (token != null) {
                self.$emit("logged-in");
                is_admin = 0;
                if (self.$route.params.nextUrl != null) {
                  self.$router.push(self.$route.params.nextUrl);
                } else {
                  if (is_admin == 1) {
                    self.$router.push("/");
                  } else {
                    if (otp == "0") {
                      self.$router.push("/");
                    } else if (otp == "1") {
                      localStorage.setItem("otp_token", otp_token);
                      self.$router.push("/otp");
                    }
                  }
                }
              }
            }
            // var keys = Object.keys( datasss.post_data );

            // for (var i = 0; i < keys.length; i++){
            //   console.log( datasss.post_data[ keys[ i ] ] )
            // }

            //console.log("error:" + response.data);
            //console.log("status:" + response.status);
            //console.log("statusText:"+response.statusText);
            //console.log("headers:"+response.headers);
            //console.log("config:"+response.config);

            self.$Progress.finish();
          })
          .catch(function (error) {
            self.$Progress.fail();
            console.log(error);
            self.authError = error ? error : "";
            self.isAuthError = true;
          });
      }
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    getData() {
        axios({
          method: "post",
          url: appConfig.baseUrl + appConfig.nms_path + "/login/page",
          headers: { "Content-Type": "multipart/form-data" },
        }).then((response)=>{
            var resData = response.data;
            if (resData.data.error == 0) {
              this.iframeLink = resData.data.sponsor_link;
              this.productShowCase = resData.data.product_showcase;
            }
          })
          .catch(function (error) {
            console.log(error)
          });
    },
    setLanguage(locale, country, flag) {
      this.$i18n.locale = locale;
      this.current_language = locale;
      this.text = country;
      this.flag = flag;

      localStorage.setItem("setting_language", this.current_language);
    },
  },
};
</script>

<style scoped>
#eye,
#eye2 {
  position: absolute;
  top: 33px !important;
  padding: 5px 10px;
  right: 5px;
  text-align: center;
  width: 40px;
  color: #999;
  z-index: 3;
  background-color: #fff;
  cursor: pointer;
}
.embed-responsive-21by9byCustom {
    position: relative; 
    display: block;
    width: 100%;
    padding-bottom: 44% !important
}
.iframe_css{ width: 100%; height: 100%; position: absolute;  top: 0px;}
.logo img{max-width:270px}
.login .card-header span{
    display:block;
    margin-bottom:3px;
    height:5px;
    margin-bottom:10px
}
.login .card-header span:before{
    content:'';
    width:80px;
    height:5px;
    background-color:#d61c28;
    display:inline-block;
    clear:both;
    position:relative;
    top:-10px;
    margin-bottom:3px;
    border-radius:5px
}

#tooltip{
    top:-17px;
    right:53px;
    position:absolute;
    height:24px
}


#expiredtxt{
    position:absolute;
    top:30px;
    left:0;
    width:100%;
    display:block;
    text-align:center;
    font-size:15px;
    color:#444
}
#refreshbutton{
    display:inline-block;
    padding:4px 12px;
    position:absolute;
    top:65px;
    left:40%;
    background-color:#e14141;
    border:0!important;
    color:#fff!important;
    -webkit-border-radius:2px;
    -moz-border-radius:2px;
    border-radius:2px
}

.banner_area{
  position: relative;
  overflow: hidden;
  padding-top: calc(100% * 1/2);
  height: 0;
  width: 100%;
}
.banner_area >>> img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner_area >>> iframe{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.nav_area{
  border-bottom: 1px solid #e8e8e8;
}

.account-pages{
  min-height: calc(100vh);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text-align-last-end{
  text-align-last:end !important
}

.custom-dropdown{
  height: 50px !important
}

.responsive-login{
  width: 430px;
}

.w-fit-content{
  width: fit-content;
}

@media (max-width: 767.98px) {
  .responsive-login{
  width: 370px;
}
}

::v-deep .dropdown-item{
  display:flex !important;
  align-items:center !important;
}
</style>
